


document.getElementById('fwTaxToggle').addEventListener('change', function() {
    
    if(this.checked) {

      pricesWithTax(1);
      localStorage.setItem('ls_pricesWithTax', '1');       
      
    } else {

        pricesWithTax(0);
        localStorage.setItem('ls_pricesWithTax', '0');
        
    }

    showToastNotification("Einstellung gespeichert");

    //alert(this.checked)

  });


/* 
function pricesWithTax(taxIncluded) {

    //alert(taxIncluded)

  document.querySelectorAll('.price__gross').forEach(element => element.style.display = taxIncluded ? 'block' : 'none');
  document.querySelectorAll('.fwPriceDescNet').forEach(element => element.style.display = taxIncluded ? 'none' : 'block');
  document.querySelectorAll('.price__current').forEach(element => element.style.display = taxIncluded ? 'none' : 'block');
  document.querySelectorAll('.fwPriceDescGross').forEach(element => element.style.display = taxIncluded ? 'block' : 'none');

}
*/

function pricesWithTax(taxIncluded) {
    const showGross = taxIncluded === 1;

    // Ihre Funktion, um die Seite zu identifizieren
    if (typeof isProductPage === 'function' && isProductPage()) {
        
        // =======================================================
        // DEFINITIVE LOGIK FÜR PRODUKTDETAILSEITEN
        // =======================================================
        const shippingToggle = document.getElementById('fwShippingToggle');
        const showShipping = shippingToggle ? shippingToggle.checked : false;

        // Schritt 1: Brutto/Netto-Container umschalten
        document.querySelectorAll('.fwNetContainer').forEach(el => el.style.display = showGross ? 'none' : 'block');
        document.querySelectorAll('.fwGrossContainer').forEach(el => el.style.display = showGross ? 'block' : 'none');

        // Schritt 2: Inkl/Exkl-Versand-Elemente umschalten
        document.querySelectorAll('.fwExclShippingPrice').forEach(el => el.style.display = showShipping ? 'none' : 'inline');
        document.querySelectorAll('.fwInclShippingPrice').forEach(el => el.style.display = showShipping ? 'inline' : 'none');

    } 

    // =======================================================
    // URSPRÜNGLICHE LOGIK ON TOP
    // =======================================================
    document.querySelectorAll('.price__gross').forEach(element => element.style.display = showGross ? 'block' : 'none');
    document.querySelectorAll('.price__current').forEach(element => element.style.display = showGross ? 'none' : 'block');
    document.querySelectorAll('.fwPriceDescNet').forEach(element => element.style.display = showGross ? 'none' : 'block');
    document.querySelectorAll('.fwPriceDescGross').forEach(element => element.style.display = showGross ? 'block' : 'none');

}



function updateTaxToggle(value) {
    document.getElementById('fwTaxToggle').checked = value === 1;
    //alert('updateTaxToggle: ' + value)
    
}

function fwSetTaxPreference() {

    var VarPricesWithTax = 0; // Standardmäßig auf Netto (0) gesetzt

    let ls_pricesWithTax = localStorage.getItem('ls_pricesWithTax');

    if (ls_pricesWithTax !== null && (ls_pricesWithTax === '0' || ls_pricesWithTax === '1')) {
        
        if (ls_pricesWithTax === '1') {           
            VarPricesWithTax = 1; // Brutto (mit MwSt.) 
        } else {
            VarPricesWithTax = 0; // Netto (ohne MwSt.)
        }
 
        pricesWithTax(VarPricesWithTax);       
        updateTaxToggle(VarPricesWithTax);

        localStorage.setItem('ls_pricesWithTax', VarPricesWithTax.toString());

    } else {

        pricesWithTax(VarPricesWithTax);
        updateTaxToggle(VarPricesWithTax)

        localStorage.setItem('ls_pricesWithTax', VarPricesWithTax.toString());
        //showTaxModal();
        
    }

    //alert("VarPricesWithTax: " + VarPricesWithTax)

}


/* function persistCartAttribute() {
    // Prüfe den LocalStorage-Wert für ls_pricesWithTax
    const ls_pricesWithTax = localStorage.getItem('ls_pricesWithTax');
  
    if (ls_pricesWithTax) {
      fwLog('LocalStorage-Wert gefunden: ls_pricesWithTax = ' + ls_pricesWithTax);
  
      // Attribut im Warenkorb setzen
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: { ls_pricesWithTax: ls_pricesWithTax },
        }),
      })
        .then(response => {
          if (response.ok) {
            fwLog('Cart-Attribut ls_pricesWithTax erfolgreich gesetzt: ' + ls_pricesWithTax);
          } else {
            fwLog('Fehler beim Setzen des Cart-Attributs ls_pricesWithTax');
          }
          return response.json();
        })
        .then(data => {
          fwLog('Cart-Response nach Attribut-Setzen:', data);
        })
        .catch(error => {
          fwLog('Fehler beim Persistieren des Cart-Attributs:', error);
        });
    } else {
      fwLog('Kein ls_pricesWithTax im LocalStorage gefunden. Kein Update erforderlich.');
    }
  }
 */


/* // Funktion zum Anzeigen des Modals
function showTaxModal() {
    var modal = document.getElementById('fwTaxModal');
    modal.style.display = 'flex'; // Modal anzeigen
}

// Funktion zum Schließen des Modals
function closeTaxModal() {
    var modal = document.getElementById('fwTaxModal');
    modal.style.display = 'none'; // Modal ausblenden
} 

// Event Listeners für die Buttons
document.getElementById('fwTaxModalBtnNetto').addEventListener('click', function() {
    pricesWithTax(0);
    localStorage.setItem('ls_pricesWithTax', '0');
    updateTaxToggle(0);
    closeTaxModal(); // Modal schließen nach Auswahl
});

document.getElementById('fwTaxModalBtnBrutto').addEventListener('click', function() {
    pricesWithTax(1);
    localStorage.setItem('ls_pricesWithTax', '1');
    updateTaxToggle(1);
    closeTaxModal(); // Modal schließen nach Auswahl
});

// Event Listener für den Close Button
document.getElementById('fwTaxModalClose').addEventListener('click', function() {
    closeTaxModal();   // Modal schließen, wenn auf den Close Button geklickt wird
});
*/



// Wenn man auf die Zeile klickt, wird die Menge im Eingabefeld auf den Wert der ersten Zelle gesetzt

function updateQuantityFromBulkPrice() {
  // Parse Staffelpreis-String
  function parseBulkPrices(str) {
    const result = {};
    str.split('|').forEach(pair => {
      const [qty, price] = pair.split(':');
      result[parseInt(qty)] = parseFloat(price);
    });
    return result;
  }

  // Preis anhand Menge ermitteln
  function getPriceByQuantity(qty, tierPrices) {
    const tiers = Object.keys(tierPrices)
      .map(Number)
      .sort((a, b) => a - b);

    let matchedTier = tiers[0];
    for (let i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i]) {
        matchedTier = tiers[i];
      } else {
        break;
      }
    }

    return tierPrices[matchedTier];
  }

  // Preise in DOM schreiben
  function updateDisplayedPrices(priceNetto) {
    const priceBrutto = priceNetto * 1.19;

    const targetCurrent = document.querySelector('.price__default .price__current');
    const targetNet = document.querySelector('.price__default .price__gross');

    if (targetCurrent) {
      targetCurrent.textContent = priceNetto.toFixed(2).replace('.', ',') + ' €';
    }

    if (targetNet) {
      targetNet.textContent = priceBrutto.toFixed(2).replace('.', ',') + ' €';
    }
  }

  // Event: Row-Klick
  function bindBulkPriceRows(tierPrices) {
    document.querySelectorAll('.fw_bulk_price_row').forEach(row => {
      if (!row.classList.contains('fw_bulk_price_footer')) {
        row.addEventListener('click', () => {
          document.querySelectorAll('.fw_bulk_price_row').forEach(r => {
            r.classList.remove('fw_bulk_price_row_active');
          });
          row.classList.add('fw_bulk_price_row_active');

          const qty = parseInt(row.querySelector('.fw_bulk_price_cell1')?.textContent.trim());
          if (!isNaN(qty)) {
            const price = getPriceByQuantity(qty, tierPrices);
            updateDisplayedPrices(price);

            const qtyInput = document.querySelector('.qty-input input.qty-input__input');
            if (qtyInput) qtyInput.value = qty;
          }
        });
      }
    });
  }


  // Event: Input-Änderung
  function bindQuantityInput(tierPrices) {
    const input = document.querySelector('.qty-input input.qty-input__input');
    if (!input) return;

    input.addEventListener('input', () => {
      const qty = parseInt(input.value);
      if (!isNaN(qty)) {
        const price = getPriceByQuantity(qty, tierPrices);
        updateDisplayedPrices(price);
      }
    });
  }

  // Init intern auslösen
  const tierPrices = parseBulkPrices(window.fwBulkPriceString || "");
  bindBulkPriceRows(tierPrices);
  bindQuantityInput(tierPrices);
}


function isProductPage() {
  var currentUrl = window.location.href;
  return currentUrl.includes('/products/');
}



function showToastNotification(message, duration = 2000) {
    const toastElement = document.getElementById('fwToastNotification');
    if (!toastElement) return;
    clearTimeout(window.toastTimer);
    toastElement.textContent = message;
    toastElement.classList.add('show');
    window.toastTimer = setTimeout(() => {
        toastElement.classList.remove('show');
    }, duration);
}





///////////////////////////////////////////////////
////////// ANFRAGELISTE — neues B2B-Schema ////////
///////////////////////////////////////////////////
// Zentrale Anfrageliste, geteilt mit dem B2B-Collection-Layout
// (sections/fw_b2b_main-collection-products.liquid). Item-Format pro Eintrag:
//   { variantId, sku, qty, step, productTitle, variantTitle, variantLabel, image, offerAlternative }
// Storage-Key: localStorage 'fwB2bAnfrageliste'. Key pro Item: variantId
// (nicht productId, weil pro Variant ein eigener Eintrag möglich sein soll —
// das B2B-Listing nutzt das genauso).
//
// Liquid-Templates müssen die nötigen data-attributes liefern:
//   .fw_coll_wishlist (Product-Card):
//     data-product-id, data-variant-id, data-sku, data-product-title,
//     data-variant-title, data-variant-label, data-image
//   #pdpAddWishlist (PDP):
//     data-product-id, data-variant-id, data-sku, data-product-title,
//     data-variant-title, data-variant-label, data-option-names, data-image

const FW_ANFRAGELISTE_KEY = 'fwB2bAnfrageliste';
const FW_ANFRAGELISTE_MAX = 20;

function fwAnfrageGet() {
  return JSON.parse(localStorage.getItem(FW_ANFRAGELISTE_KEY) || '{}');
}
function fwAnfrageSet(data) {
  localStorage.setItem(FW_ANFRAGELISTE_KEY, JSON.stringify(data));
}
function fwAnfrageHas(variantId) {
  if (!variantId) return false;
  return !!fwAnfrageGet()[String(variantId)];
}

// Item hinzufügen. Erwartet ein Objekt mit mindestens variantId — alle weiteren
// Felder werden defensiv mit Defaults befüllt. Triggert Counter-Update + GA4-Event.
// item.source steuert den GTM-Event-Namen:
//   'pdp'        → b2b_pdp_request_product_added
//   'collection' → b2b_collection_request_product_added (Default)
function fwAnfrageAdd(item) {
  const data = fwAnfrageGet();
  if (Object.keys(data).length >= FW_ANFRAGELISTE_MAX && !data[String(item.variantId)]) {
    alert(`Die Anfrageliste kann maximal ${FW_ANFRAGELISTE_MAX} Produkte enthalten.`);
    return false;
  }
  const key = String(item.variantId);
  data[key] = {
    sku:              item.sku || '',
    qty:              parseInt(item.qty) || 1,
    step:             parseInt(item.step) || 1,
    variantId:        parseInt(item.variantId),
    productTitle:     item.productTitle || '',
    variantTitle:     item.variantTitle || '',
    variantLabel:     item.variantLabel || item.variantTitle || '',
    image:            item.image || '',
    priceCents:       parseInt(item.priceCents) || 0,
    offerAlternative: !!item.offerAlternative
  };
  fwAnfrageSet(data);
  fwAnfrageUpdateCount();
  if (typeof trackAddToAnfrageliste === 'function') {
    trackAddToAnfrageliste(item.variantId, data[key].qty);
  }
  // GTM-Event — getrennt nach Aufruf-Kontext (PDP vs. Collection-Karte),
  // damit GTM beide Quellen separat auswerten kann. Payload-Schema sonst identisch.
  const eventName = item.source === 'pdp'
    ? 'b2b_pdp_request_product_added'
    : 'b2b_collection_request_product_added';
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    variant_id: data[key].variantId,
    sku: data[key].sku,
    product_title: data[key].productTitle,
    variant_title: data[key].variantTitle,
    quantity: data[key].qty,
    price: data[key].priceCents / 100,
    is_custom: false
  });
  return true;
}

// Wunschartikel-Eintrag (isFree:true) mit Pseudo-Variant-ID "free_<ts>_<r>".
// Wird vom Promo-Card-Trigger auf der regulaeren Collection genutzt; nutzt
// dieselbe Anfrageliste wie fwAnfrageAdd. Kein parseInt der variantId und kein
// MAX-Block (User-Aktion). Gibt die neue ID zurueck (zum Fokussieren im Modal).
function fwAnfrageAddWish() {
  const freeId = 'free_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
  const data = fwAnfrageGet();
  data[freeId] = {
    isFree:           true,
    variantId:        freeId,
    sku:              '',
    qty:              1,
    step:             1,
    productTitle:     '',
    variantTitle:     '',
    variantLabel:     '',
    image:            null,
    priceCents:       0,
    offerAlternative: false
  };
  fwAnfrageSet(data);
  fwAnfrageUpdateCount();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'b2b_collection_request_product_added',
    variant_id: freeId,
    sku: '',
    product_title: '',
    variant_title: '',
    quantity: 1,
    price: 0,
    is_custom: true
  });
  return freeId;
}

function fwAnfrageRemove(variantId) {
  const data = fwAnfrageGet();
  delete data[String(variantId)];
  fwAnfrageSet(data);
  fwAnfrageUpdateCount();
}

// Counter im Header-Icon + Icon-Farbe (orange wenn ≥1 Item) updaten.
function fwAnfrageUpdateCount() {
  const count = Object.keys(fwAnfrageGet()).length;
  const countEl = document.getElementById('fwWishlistCount');
  if (countEl) {
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
  }
  // Header-Icon (orange/standard switchen)
  const iconEl = document.getElementById('fwWishlistIcon');
  if (iconEl && iconEl.dataset.standard && iconEl.dataset.orange) {
    iconEl.src = count > 0 ? iconEl.dataset.orange : iconEl.dataset.standard;
  }
}

// variantLabel wie im B2B-Liquid bauen: "Farbe: Schwarz, Größe: 7"
// Erwartet ein Variant-Objekt aus dem variant-picker (option1/2/3) und einen
// CSV-String mit Option-Namen ("Farbe,Größe").
function fwAnfrageBuildVariantLabel(optionNamesCsv, variant) {
  const names = (optionNamesCsv || '').split(',').map(s => s.trim()).filter(Boolean);
  const opts = [variant.option1, variant.option2, variant.option3];
  return names
    .map((n, i) => opts[i] ? `${n}: ${opts[i]}` : null)
    .filter(Boolean)
    .join(', ');
}

// Bindet Click-Handler an alle .fw_coll_wishlist (Product-Cards) und an
// #pdpAddWishlist (PDP). Wird bei DOMContentLoaded und bei AJAX-Updates des
// Listings (siehe fw__js-cart-max-listing.js.liquid) aufgerufen.
function fwAnfrageInitButtons() {
  fwAnfrageUpdateCount();

  // ── Product-Cards ──
  document.querySelectorAll('.fw_coll_wishlist').forEach(divEl => {
    const variantId = divEl.dataset.variantId;
    const imgEl = divEl.querySelector('img');
    const standardSvg = imgEl?.dataset.standard;
    const orangeSvg = imgEl?.dataset.orange;

    // Initialer Icon-Status
    if (imgEl && variantId) {
      const inList = fwAnfrageHas(variantId);
      if (inList && orangeSvg) imgEl.src = orangeSvg;
      else if (!inList && standardSvg) imgEl.src = standardSvg;
    }

    if (divEl._anfrageHandler) divEl.removeEventListener('click', divEl._anfrageHandler);

    const handler = () => {
      const vid = divEl.dataset.variantId;
      if (!vid) return;
      const productId = divEl.dataset.productId;
      const qtyInput = document.querySelector(`.qty-input__input[data-product-id='${productId}']`);
      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      if (fwAnfrageHas(vid)) {
        fwAnfrageRemove(vid);
        if (imgEl && standardSvg) imgEl.src = standardSvg;
        return;
      }

      const ok = fwAnfrageAdd({
        variantId:    vid,
        sku:          divEl.dataset.sku,
        productTitle: divEl.dataset.productTitle,
        variantTitle: divEl.dataset.variantTitle,
        variantLabel: divEl.dataset.variantLabel,
        image:        divEl.dataset.image,
        priceCents:   divEl.dataset.priceCents,
        qty,
        step: 1,
        source: 'collection'
      });
      if (!ok) return;
      if (imgEl && orangeSvg) imgEl.src = orangeSvg;
      if (imgEl) {
        imgEl.classList.add('animate-scale');
        setTimeout(() => imgEl.classList.remove('animate-scale'), 300);
      }
    };

    divEl._anfrageHandler = handler;
    divEl.addEventListener('click', handler);
  });

  // ── PDP-Button ──
  const pdpBtn = document.getElementById('pdpAddWishlist');
  if (!pdpBtn) return;

  // Initialen Status setzen
  pdpBtn.classList.toggle('btn--tertiary--disabled', fwAnfrageHas(pdpBtn.dataset.variantId));

  if (pdpBtn._anfrageHandler) pdpBtn.removeEventListener('click', pdpBtn._anfrageHandler);

  const pdpHandler = () => {
    const vid = pdpBtn.dataset.variantId;
    if (!vid) return;
    const productId = pdpBtn.dataset.productId;
    const qtyInput = document.querySelector(`.qty-input__input[data-product-id='${productId}']`);
    const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (fwAnfrageHas(vid)) {
      fwAnfrageRemove(vid);
      pdpBtn.classList.remove('btn--tertiary--disabled');
      return;
    }

    const ok = fwAnfrageAdd({
      variantId:    vid,
      sku:          pdpBtn.dataset.sku,
      productTitle: pdpBtn.dataset.productTitle,
      variantTitle: pdpBtn.dataset.variantTitle,
      variantLabel: pdpBtn.dataset.variantLabel,
      image:        pdpBtn.dataset.image,
      priceCents:   pdpBtn.dataset.priceCents,
      qty,
      step: 1,
      source: 'pdp'
    });
    if (ok) pdpBtn.classList.add('btn--tertiary--disabled');
  };

  pdpBtn._anfrageHandler = pdpHandler;
  pdpBtn.addEventListener('click', pdpHandler);
}

// Variant-Wechsel auf der PDP: data-attributes des #pdpAddWishlist updaten,
// damit die richtige Variant in die Anfrageliste wandert. Das variant-picker.js
// dispatched 'on:variant:change' mit detail.variant.
document.addEventListener('on:variant:change', e => {
  const pdpBtn = document.getElementById('pdpAddWishlist');
  const variant = e.detail?.variant;
  if (!pdpBtn || !variant) return;
  pdpBtn.dataset.variantId    = variant.id;
  pdpBtn.dataset.sku          = variant.sku || '';
  pdpBtn.dataset.variantTitle = variant.title || '';
  pdpBtn.dataset.variantLabel = fwAnfrageBuildVariantLabel(pdpBtn.dataset.optionNames, variant) || variant.title || '';
  if (variant.featured_image?.src) pdpBtn.dataset.image = variant.featured_image.src;
  // Im variant-picker.js ist variant.price in Cents-Integer (Shopify-Convention)
  if (typeof variant.price === 'number') pdpBtn.dataset.priceCents = String(variant.price);
  pdpBtn.classList.toggle('btn--tertiary--disabled', fwAnfrageHas(variant.id));
});

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

// ── Backward-Compat-Aliase ──
// fw__js-cart-max-listing.js.liquid ruft initializeWishlistWithQuantity nach
// AJAX-Cart/Collection-Updates auf. Andere Stellen prüfen typeof === 'function'.
function initializeWishlistWithQuantity() { fwAnfrageInitButtons(); }
function updateWishlistCountWithQuantity() { fwAnfrageUpdateCount(); }


///////////////////////////////////////////////////
////////// Tracking ///////////////////////////////

function fwHasAdUserDataConsent() {
  const dl = window.dataLayer || [];
  for (let i = dl.length - 1; i >= 0; i--) {
    const entry = dl[i];
    if (entry && entry[0] === 'consent' && entry[1] === 'update' && entry[2]?.ad_user_data === 'granted') {
      return true;
    }
  }
  return false;
}

function fwFillInternField(shadowRoot, betreff) {
  let trackingData = '';

  if (fwHasAdUserDataConsent()) {
    const gaId = localStorage.getItem('fw_ga_id');
    const msId = localStorage.getItem('fw_ms_id');
    const trackingValues = [];
    if (gaId) trackingValues.push(gaId);
    if (msId) trackingValues.push(msId);
    const ids = trackingValues.join('|');
    if (ids) trackingData = `${betreff}: ${ids}`;
  }

  fwLog("Internfield-Data:", trackingData);

  const internInput = shadowRoot.querySelector('#custom\\#intern');
  if (internInput) {
    internInput.value = trackingData;
    internInput.setAttribute('readonly', true);
    internInput.style.color = '#BBB';
    internInput.dispatchEvent(new Event('input', { bubbles: true }));
    if (internInput.parentElement) {
      internInput.parentElement.style.display = 'none';
    }
  }
}

function trackAddToAnfrageliste(productId, quantity) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_anfrageliste",
        product: {
            id: productId,
            quantity: quantity
        }
    });

    fwLog("Event add_anfrageliste gesendet:", productId, quantity);
}


// Track Google & Microsoft IDs for 
// Offline-Conversions of Request-Forms
///////////////////////////////////////////////////

function storeAdClickIds() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Lokales Datum im Format YYYY-MM-DD generieren (robuster als UTC für deine Zeitzone)
    const dateObj = new Date();
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const currentDate = `${year}-${month}-${day}`;

    // Hilfsfunktion: Parameter auslesen (ignoriert Groß-/Kleinschreibung & fängt leere Werte ab)
    function getCleanParamValue(paramName) {
        for (const [key, value] of urlParams.entries()) {
            if (key.toLowerCase() === paramName.toLowerCase() && value.trim() !== "") {
                return value.trim();
            }
        }
        return null;
    }

    // --- 1. GOOGLE IDs VERARBEITEN ---
    // Werte sicher aus der URL ziehen
    const gclid = getCleanParamValue('gclid');
    const wbraid = getCleanParamValue('wbraid');
    const gbraid = getCleanParamValue('gbraid');

    let googleIdName = null;
    let googleIdValue = null;

    // Hierarchie beachten: GCLID > WBRAID > GBRAID
    if (gclid) {
        googleIdName = 'GCLID';
        googleIdValue = gclid;
    } else if (wbraid) {
        googleIdName = 'WBRAID';
        googleIdValue = wbraid;
    } else if (gbraid) {
        googleIdName = 'GBRAID';
        googleIdValue = gbraid;
    }

    // Wenn ein valider Google-Wert existiert -> Speichern
    if (googleIdName && googleIdValue) {
        localStorage.setItem('fw_ga_id', `${currentDate};${googleIdName};${googleIdValue}`);
    }

    // --- 2. MICROSOFT ID VERARBEITEN ---
    const msclkid = getCleanParamValue('msclkid');
    
    // Wenn ein valider Microsoft-Wert existiert -> Speichern
    if (msclkid) {
        localStorage.setItem('fw_ms_id', `${currentDate};MSCLKID;${msclkid}`);
    }
}



///////////////////////////////////////////////////
////////// shipping modal /////////////////////////

const storefrontAccessToken = "4ad31dcf66643de20f6de5fb145e4c6c";

const loadShippingPolicy = async (scrollInvoice = false) => {

  //document.getElementById('fwModalContainer').style.display = 'block';

  try {

    const loader = document.getElementById('fwModalLoader');
    const content = document.getElementById('fwModalContent');

    // Loader anzeigen und Inhalt leeren
    loader.style.display = 'block';
    content.innerHTML = '';

    document.body.style.overflow = 'hidden';
    document.getElementById('fwModalContainer').style.display = 'block';

      const response = await fetch('/api/2023-01/graphql.json', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
          body: JSON.stringify({
              query: `{
                  shop {
                      shippingPolicy {
                          body
                      }
                  }
              }`
          }),
      });

      const data = await response.json();

      fwLog("Shipping geladen:", data);

      const policy = data.data.shop.shippingPolicy;

      if (policy) {
          const content = document.getElementById('fwModalContent');
          content.innerHTML = `<h2>Versandkosten</h2><p>${policy.body}</p>`;

          if (scrollInvoice) {
            setTimeout(() => {
              const anchor = document.querySelector('#fwModalContent #buyInvoice');
              if (anchor) {
                anchor.scrollIntoView({ behavior: 'smooth' });
                anchor.style.fontWeight = 'bold';
              }
            }, 100);
        } 
          
      } else {
          console.error('Keine Shipping-Policy gefunden.');
      }
  } catch (error) {
      console.error('Fehler beim Laden der Shipping-Policy:', error);
  } finally {
    document.getElementById('fwModalLoader').style.display = 'none';
  }
};


// Schließen des Modals und Scrollen aktivieren
const closeModal = () => {
  document.getElementById('fwModalContainer').style.display = 'none';
  document.body.style.overflow = 'auto';
  document.body.style.paddingRight = '';
};

// Hintergrund-Klick zum Schließen des Modals
document.getElementById('fwModalContainer').addEventListener('click', (event) => {
  if (event.target.id === 'fwModalContainer') {
      closeModal();
  }
});



///////////////////////////////////////////////////
////////// initialise on page load ////////////////

document.addEventListener('DOMContentLoaded', () => {

    if (isProductPage()) {
      //updateQuantityFromBulkPrice();
    }

    fwSetTaxPreference();
    initializeWishlistWithQuantity();
    storeAdClickIds();
    //persistCartAttribute();

});



///////////////////////////////////////////////////////////////////////////////////////////
/////// MOBILE: Kachelansicht erzwingen, Umschaltung Text auf Collection-Seite ////////////

document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth <= 768;
    const isRelevantPage = window.location.href.includes("collection") || window.location.href.includes("search");
  
    if (isMobile && isRelevantPage) {

      const listOption = document.getElementById("list-layout-opt");
      const gridOption = document.getElementById("grid-layout-opt");
  
      if (listOption && gridOption) {
        listOption.removeAttribute("checked");
        gridOption.setAttribute("checked", "checked");
  
        // Listenansicht-Label ausblenden
        const listLabel = document.querySelector('label[for="list-layout-opt"]');
        if (listLabel) {
          listLabel.style.display = "none";
        }
  
        // Sichere Umschaltung für iOS/Safari
        setTimeout(() => {
          gridOption.dispatchEvent(new Event("change", { bubbles: true }));
          gridOption.click();
        }, 50);
      }

      // Code für die "Mehr anzeigen"-Funktionalität
      const descriptionContainers = document.querySelectorAll('.fw_collection_banner_desc');

      descriptionContainers.forEach(function(descriptionContainer) {
          const readMoreToggle = descriptionContainer.querySelector('.read-more-toggle');

          if (readMoreToggle) { // Sicherstellen, dass der Toggle-Link existiert
            readMoreToggle.addEventListener('click', function(e) {
              e.preventDefault();

              const shortDesc = descriptionContainer.querySelector('.short-description');
              const isExpanded = descriptionContainer.classList.toggle('expanded');

              if (isExpanded) {
                shortDesc.style.display = 'block';
                shortDesc.style.webkitBoxOrient = 'vertical';
                shortDesc.style.webkitLineClamp = 'unset';
                shortDesc.style.overflow = 'visible';
                this.textContent = 'weniger';
              } else {
                shortDesc.style.display = '-webkit-box';
                shortDesc.style.webkitBoxOrient = 'vertical';
                shortDesc.style.webkitLineClamp = '1';
                shortDesc.style.overflow = 'hidden';
                this.textContent = 'mehr';
              }
            });
          }
      });

    }

  });
  

function scrollDown(){
  window.scroll({
      top: document.body.scrollHeight,
      behavior: 'smooth'
  });
}